import * as React from 'react';
import { memo } from 'react';

const NightsBooked = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M37.1693 29.167H3.83594"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.1693 35V26.6667C37.1693 23.524 37.1693 21.9527 36.1929 20.9763C35.2166 20 33.6453 20 30.5026 20H10.5026C7.3599 20 5.78855 20 4.81225 20.9763C3.83594 21.9527 3.83594 23.524 3.83594 26.6667V35"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M27.1693 20V17.6963C27.1693 16.8505 27.0168 16.5676 26.2353 16.2342C24.6078 15.5398 22.6323 15 20.5026 15C18.3729 15 16.3974 15.5398 14.7699 16.2342C13.9885 16.5676 13.8359 16.8505 13.8359 17.6963V20"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M33.8307 20V12.2676C33.8307 11.1149 33.8307 10.5385 33.5461 9.99422C33.2614 9.44992 32.8559 9.16818 32.0447 8.60472C28.7742 6.33297 24.7927 5 20.4974 5C16.2021 5 12.2206 6.33297 8.95011 8.60472C8.13893 9.16818 7.73335 9.44992 7.44871 9.99422C7.16406 10.5385 7.16406 11.1149 7.16406 12.2676V20"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const Memo = memo(NightsBooked);
export default Memo;
